/**
 * Copyright (c) Streamlit Inc. (2018-2022) Snowflake Inc. (2022-2026)
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { parseUserAgent } from "@streamlit/utils"

/**
 * Utilizes user agent to determine if the user is on a mobile device.
 * Note: This is a simple heuristic and may not be 100% accurate.
 *
 * @returns true if the user is on a mobile device, false otherwise
 */
export function isMobile(): boolean {
  return parseUserAgent(navigator.userAgent).deviceType === "mobile"
}
